import { useGamesStore } from '@nsftx/seven-client-retail-vue-sgp'
import { useCmsConfigStore } from '@/stores/cms/cmsConfigStore'

/**
 * Boots game links from CMS `/ssbt/bootstrap` `games.docs`
 * (gm-game-links resolved for the device's active product referenceIds).
 */
const bootGames = () => {
  const { cmsConfig } = useCmsConfigStore()
  const { setGameLinks } = useGamesStore()

  setGameLinks(cmsConfig?.games?.docs ?? [])
}

export { bootGames }
